// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Layout */
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}

.b-0 {
  bottom: 0;
}

/* Unfortunately both .flex and .d-flex are used by Vuetify */
.display-flex {
  display: flex;
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}

.items-center {
  align-items: center;
}

.justify-between {
  justify-content: space-between;
}

.h-100 {
  height: 100%;
}

.gap-2 {
  gap: 0.5rem;
}

.overflow-y-hidden {
  overflow-y: hidden;
}

/* Text */
.text-sm {
  font-size: 0.8rem;
}
.text-base {
  font-size: 1rem;
}
.text-lg {
  font-size: 1.2rem;
}

/* Decoration */
.rounded-none {
  border-radius: 0 !important;
}
.rounded-full {
  border-radius: 9999px;
}

.cursor-pointer {
  cursor: pointer;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
